@if (isVisible) {
  <div class="ag-cell-editor ag-labeled ag-label-align-left ag-text-field ag-input-field" (keydown)="onKeyDown($event)">
    <div class="ag-input-field-label ag-label ag-hidden ag-text-field-label">
    </div>
    <div class="ag-wrapper">
      <div class="checkbox">
        <input #checkboxInput class="show-for-sr no-margin vertical-align-middle" type="checkbox" [checked]="isChecked" />
        <label (click)="onClick()" class="text-align-center display-inline-block">
          <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
        </label>
      </div>
    </div>
  </div>
}
